<template>
  <div>
    <div v-if="operasiLaporan">
      <div class="d-flex flex-between my-3">
        <h4 class="text-uppercase mb-0">Laporan Operasi</h4>
        <router-link
          :to="
            `/operasi/form-laporan/${$route.params.id_ralan}/${$route.params.id}?fromTab=0`
          "
          class="btn btn-with-icon-left btn-primary text-uppercase"
        >
          <i class="material-symbols-outlined">create</i>
          Ubah Laporan Operasi
        </router-link>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <FormRow
            v-for="row in upperForm"
            v-bind:key="row.colnum + String(Math.random(1023))"
            :row="row"
            @handleChange="(e) => handleChange(e)"
          />
        </div>
      </div>
      <hr />
      <div class="row mb-5">
        <div class="col-md-6">
          <FormRow
            v-for="row in leftForm"
            v-bind:key="row.colnum + String(Math.random(1023))"
            :row="row"
            @handleChange="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-6">
          <FormRow
            v-for="row in rightForm"
            v-bind:key="row.colnum + String(Math.random(1023))"
            :row="row"
            @handleChange="(e) => handleChange(e)"
          />
        </div>
      </div>
    </div>
    <EmptyState v-else :data="empty" />
  </div>
</template>

<script>
// @ is an alias to /src
import FormRow from "@/components/FormRow.vue";
// import { setOperationIntro } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import {
  upperFormLaporan,
  leftFormLaporan,
  rightFormLaporan,
} from "@/data/OperasiDetail.js";
import { dataOperasi } from "@/data/OperasiForm.js";
import EmptyState from "@/components/EmptyState.vue";
export default {
  props: { ralan: Object, operasi: Object },
  name: "OperasiFormLaporan",
  components: {
    EmptyState,
    FormRow,
  },
  data: () => {
    return {
      empty: {
        img: "/img/nurse.svg",
        title: "Belum ada laporan operasi",
        content:
          "Isi data laporan operasi dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/operasi/form-laporan/",
        label: "input laporan operasi",
      },
      data: dataOperasi,
      detailTop: null,
      upperForm: upperFormLaporan,
      leftForm: leftFormLaporan,
      rightForm: rightFormLaporan,
      operasiLaporan: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      id_laporan: null,
      formSet: {
        id_operasi: null,
        durasi: null,
        id_operasi_ruangan: 1,
        id_dokter_operator: 1,
        id_dokter_anestesi: null,
        // "id_dokter_referal": null,
        id_perawat_instrumen: null,
        id_perawat_anestesi: null,
        id_perawat_sirkuler_1: null,
        id_perawat_sirkuler_2: null,
        id_perawat_sirkuler_3: null,
        id_perawat_sirkuler_4: null,
        id_perawat_sirkuler_5: null,
        diagnosa_pra_operasi: null,
        diagnosa_post_operasi: null,
        komplikasi: null,
        jumlah_pendarahan: null,
        jaringan_PA: null,
        asal_jaringan: null,
        time_start: "",
        time_end: "",
        kategori_tindakan: "",
        golongan_tindakan: "",
        jenis_anastesi: "",
        implant: "",
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    save: async function() {
      this.handleForm();
    },
    continue: function() {
      this.$router.push(
        `/operasi/form-tindakan/${this.$route.params.id_ralan}/${this.$route.params.id}`
      );
    },
    saveAndContinue: async function() {
      this.handleForm(this.continue);
    },
    handleForm: async function(callback) {
      this.errors = [];
      let formData = new FormData();
      let body = "";
      var self = this;
      ////console.log(this.formSet);
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          ////console.log("==================formdata========");
          ////console.log(key);
          ////console.log(self.formSet[key]);
          ////console.log("==================formdata========");
          if (
            key == "id_perawat_sirkuler_4" ||
            key == "id_perawat_sirkuler_5"
          ) {
            // if(self.formSet[key]){
            if (
              key == "id_perawat_sirkuler_5" &&
              !self.formSet["id_perawat_sirkuler_4"]
            ) {
              formData.append("id_perawat_sirkuler_4", self.formSet[key]);
              body += `id_perawat_sirkuler_4=${self.formSet[key]}&`;
            } else {
              formData.append(key, self.formSet[key]);
              body += `${key}=${self.formSet[key]}&`;
            }
            // }
          } else {
            formData.append(key, self.formSet[key]);
            body += `${key}=${self.formSet[key]}&`;
          }
        });
        try {
          let result;
          ////console.log('Id Laporan: '+this.id_laporan);
          if (this.id_laporan) {
            result = await this.$store.state.HTTP_ENC.put(
              "operasi_laporan/" + this.id_laporan,
              body
            );
          } else {
            result = await this.$store.state.HTTP.post(
              "operasi_laporan",
              formData
            );
          }
          ////console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              // that.$router.push(`/ralan/detail/${that.$route.params.id}`);
              if (callback) {
                callback();
              }
            }, 1000);
          } else {
            ////console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          ////console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        ////console.log("tidak valid");
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        ////console.log("====================onchange===========");
        ////console.log(e.target.name);
        ////console.log(e.target.value);
        ////console.log("====================onchange===========");
        this.formSet[e.target.name] = e.target.value;
      }
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
      return valid;
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let doctors = result.data.data;
          ////console.log(doctors);
          this.leftForm[0].columns[0].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          this.leftForm[1].columns[0].options = this.leftForm[0].columns[0].options;
          // this.leftForm[2].columns[0].options=this.leftForm[0].columns[0].options;
        } else {
          this.displayNotFoundError();
        }
        // this.fetchNurses();
      } catch (e) {
        ////console.log(e);
      }
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_laporan?id_operasi=${this.$route.params.id}`
      );
      //console.log(result);
      //console.log(result.data);
      //console.log(result.data.data);
      if (result.data.data.length) {
        this.id_laporan = result.data.data[0].id;
        let self = this;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_laporan/${this.id_laporan}`
        );
        //console.log(result2);
        this.operasiLaporan = result2.data;
        //console.log(this.operasiLaporan);
        Object.keys(this.formSet).forEach(function(key) {
          // if(!(key=='id_perawat_sirkuler_1'||key=='id_perawat_sirkuler_2'||key=='id_perawat_sirkuler_3'||key=='id_perawat_sirkuler_4'||key=='id_perawat_sirkuler_5')){
          // }
          self.formSet[key] = self.operasiLaporan[key];
        });
        ////console.log(this.operasiLaporan.operasi_laporan_perawat_sirkuler);
        // this.operasiLaporan.operasi_laporan_perawat_sirkuler.forEach(function(item,index){
        //   self.formSet[`id_perawat_sirkuler[${index}]`]=item.id_perawat;
        // });
        this.updateForm();
      }
    },
    updateForm() {
      let self = this;
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        ////console.log(result);
        if (result.status == "200") {
          this.leftForm[3].columns[0].options = result.data.data.map((item) => {
            return { value: item.id, label: item.nama };
          });
          if (!this.formSet.id_petugas) {
            this.formSet.id_petugas = this.$store.state.id_petugas || "";
            if (this.formSet.id_petugas) {
              this.leftForm[3].columns[0].value = this.formSet.id_petugas;
            }
          }
          this.leftForm[2].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[4].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[5].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[6].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[7].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[8].columns[0].options = this.leftForm[3].columns[0].options;
          this.leftForm[9].columns[0].options = this.leftForm[3].columns[0].options;
        } else {
          this.displayNotFoundError();
        }
        // this.fetchData();
      } catch (e) {
        ////console.log(e);
      }
    },
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.empty.link +=
      this.$route.params.id_ralan + "/" + this.$route.params.id + "?fromTab=0";
    this.formSet["id_operasi"] = this.$route.params.id;
    await this.fetchDoctors();
    await this.fetchNurses();
    await this.fetchData();
  },
};
</script>
